import { SET_INITIAL_ROUTE, SET_REDIRECT, SET_URL_SEARCH_PARAMS } from './types'

import { RouterState } from './types'

export const initialRouterState: RouterState = {
  redirect: '',
  prevRoute: '',
  initialRoute: null,
  footerRoutes: [
    '/teams',
    '/sessionsetup',
    '/activitylist',
    '/dashboard',
    '/settings',
    '/',
    '/pitch'
  ],
  urlSearchParams: null,
  action: null
}

export function routerReducer(
  state = initialRouterState,
  action: { type: string; payload?: any }
) {
  switch (action.type) {
    case SET_REDIRECT:
      return {
        ...state,
        prevRoute: state.redirect || state.initialRoute,
        redirect: action.payload.route,
        action: action.payload.action
      }
    case SET_INITIAL_ROUTE:
      return {
        ...state,
        initialRoute: action.payload
      }
    case SET_URL_SEARCH_PARAMS:
      return {
        ...state,
        urlSearchParams: action.payload
      }
    default:
      return state
  }
}
